<header
  class="bg-[#005f7f] text-white px-5 flex justify-between items-center shadow-md"
>
  <img
    class="ml-[-30px]"
    ngSrc="Product_Logo_Traction_white_tagless_optimized.png"
    height="60"
    width="228.6"
    alt="White Traction Travel Logo"
    priority
  />
  <div class="flex items-center space-x-4">
    @if (agencyService.agenciesResource.value(); as agencies) {
      @if (agencies.length === 1) {
        <div class="flex items-center h-[56px] px-4">
          <span class="font-medium">{{
            agencies[0].displayName || 'Loading...'
          }}</span>
        </div>
      } @else if (agencies.length > 1) {
        <div class="border border-gray-300 rounded-md text-white p-2">
          <select
            class="focus:outline-none cursor-pointer"
            (change)="onAgencyChange($event)"
          >
            @for (agency of agencies; track agency.id) {
              <option
                class="bg-[#2d303f] cursor-pointer"
                [value]="agency.id"
                [selected]="agency.id === agencyService.selectedAgencyID()"
              >
                {{ agency?.displayName || 'Loading...' }}
              </option>
            }
          </select>
        </div>
      }
    } @else if (agencyService.agenciesResource.error()) {
      <span class="text-red-500">{{
        agencyService.agenciesResource.error()
      }}</span>
    }
    <button
      class="cursor-pointer text-sm font-medium border border-white rounded-md px-3 py-1.5 hover:bg-white hover:text-[#005f7f] transition-colors"
      (click)="clearFilters()"
    >
      Clear Filters
    </button>
    <button
      class="p-2 focus:outline-none cursor-pointer"
      (mouseenter)="onHelpMouseEnter($event)"
      (mouseleave)="onHelpMouseLeave()"
    >
      <i class="material-icons">help_outline</i>
    </button>
    <button class="cursor-pointer" (click)="authService.logout()">
      <i class="material-icons">exit_to_app</i>
    </button>
  </div>
</header>

<help-popover
  [visible]="helpPopoverVisible()"
  [position]="helpPopoverPosition()"
  (mouseEnter)="onPopoverMouseEnter()"
  (mouseLeave)="onPopoverMouseLeave()"
/>
